import config, { EnterPriseType } from '@src/js/service/enterprise/temp-config';

export const ADDON_ID_FORMULA = config.supportEnterprise(EnterPriseType.ALL) ? '8856ef52bd434c2d938fbf0c16d82a96' : '42da4f2d95c146abb5896087ca5f03dd';
export const ADDON_ID_INSERT =  '0b69e1b9517e44a4aee35d33ee021b55';

// 云编文档临时屏蔽固定的插件项，二期此变量废除，修改为通过插件项数据的判断
export const DISABLE_ADDON_ID_FOR_DRIVE = [
    'e0b026441751437d8b0c45ff29b508c3',  // 酷狗音乐
    '20c67635951045dda4e0fcd3ac7e24d3',  // "镝数图表"
    'c0f0506f24df4e4a8e99717c2bf18b50',  // MasterGo
    '9c468c59da0e4e21a4063970ab9036d4',  // "摹客设计稿"
    '0b69e1b9517e44a4aee35d33ee021b55',  // 第三方内容
    '9e2c26161b684629a9bf29e52efa6c60',  // 视频剪辑
];
